<div>
  <ul>
    <li class="missing-color legend-text"><fa-icon [icon]="faFile"></fa-icon> Pending Submission</li>
    <li class="pending-color legend-text"><fa-icon [icon]="faFileSignature"></fa-icon> Pending Review</li>
    <li class="rejected-color legend-text"><fa-icon [icon]="faFileExclamation"></fa-icon> Pending Resubmission</li>
    <li class="accepted-color legend-text"><fa-icon [icon]="faFileCheck"></fa-icon> Complete</li>
  </ul>
</div>
